import { ButtonGroup, ButtonGroupItem } from '@99designs/common/components/ButtonGroup';
import DesignFigure from 'common/components/DesignFigure';
import Heading from 'common/components/Heading';
import React from 'react';

interface Props {
    heading: string;
    paragraph: string;
    imageSource: string;
    attributon: string;
    href: string;
    ctaText: string;
    color: string;
}

export default class BriefGetStartedUpsell extends React.Component<Props> {
    render() {
        return (
            <section className="section">
                <div className="row">
                    <div className="column">
                        <div className="bordered-column">
                            <div className="bordered-column__item">
                                <div className="bordered-column__item__content">
                                    <Heading
                                        size="h4"
                                        withDivider={true}
                                        variations={['heading--heritage']}
                                    >
                                        {'Need other design work?'}
                                    </Heading>
                                    <p className="paragraph paragraph--root paragraph--capped paragraph--no-margin paragraph--offset">
                                        {
                                            'Yep, we do that too. Get the perfect logo design—or any design in over 90 categories! Whatever your business need or budget, we’ll help get it done.'
                                        }
                                    </p>
                                    <div className="paragraph paragraph--spacious-bottom">
                                        <DesignFigure
                                            imageSource={require(`images/smartshoot/confirmation/upsell/ss-video-confirmed-design.png`)}
                                            attribution={'by Mad Pepper'}
                                        />
                                    </div>
                                    <ButtonGroup variations={['responsive']}>
                                        <ButtonGroupItem>
                                            <a
                                                className={
                                                    'button button--jumbo button--fluid button--primary'
                                                }
                                                href={'/categories'}
                                            >
                                                <span className="button__inner">
                                                    <span className="button__label">
                                                        See all design categories
                                                    </span>
                                                </span>
                                            </a>
                                        </ButtonGroupItem>
                                    </ButtonGroup>
                                </div>
                            </div>
                            <div className="bordered-column__item">
                                <div
                                    className="bordered-column__item__content"
                                    style={{ color: this.props.color }}
                                >
                                    <Heading
                                        size="h4"
                                        withDivider={true}
                                        variations={['heading--chameleon']}
                                    >
                                        {this.props.heading}
                                    </Heading>
                                    <p className="paragraph paragraph--root paragraph--capped paragraph--offset">
                                        {this.props.paragraph}
                                    </p>
                                    <div className="paragraph paragraph--spacious-bottom">
                                        <DesignFigure
                                            imageSource={this.props.imageSource}
                                            attribution={this.props.attributon}
                                        />
                                    </div>
                                    <ButtonGroup
                                        variations={['responsive']}
                                        style={{ color: this.props.color }}
                                    >
                                        <ButtonGroupItem>
                                            <a
                                                className={
                                                    'button button--chameleon button--primary button--jumbo button--fluid button--responsive'
                                                }
                                                href={this.props.href}
                                            >
                                                <span className="button__inner">
                                                    <span className="button__label">
                                                        {this.props.ctaText}
                                                    </span>
                                                </span>
                                            </a>
                                        </ButtonGroupItem>
                                    </ButtonGroup>
                                </div>
                                `
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
